import { defineMessage } from 'services/localization';

export const messages = {
    successPopupMessage: defineMessage('migration_successful'),
    description: defineMessage('you_can_now_start_using_ing_on_approval_feature'),
    great: defineMessage('great'),
};
